<template>
  <form
    ref="form"
    class="login-form"
    accept-charset="UTF-8"
    @submit.prevent="login"
  >
    <v-input
      :label="$t('login')"
      type="text"
      name="spree_user[login]"
      tabindex="1"
    />

    <v-input
      :label="$t('password')"
      name="spree_user[password]"
      type="password"
      tabindex="2"
    />

    <input value="true" type="hidden" name="spree_user[remember_me]" />
    <input
      :value="$store.state.siteStore.id"
      type="hidden"
      name="spree_user[store_id]"
    />

    <nuxt-link
      class="login-form__forgot-password"
      to="user/spree_user/password/new"
      >{{ $t('forgot_your_password') }}</nuxt-link
    >

    <v-button
      type="submit"
      name="commit"
      :label="$t('login_submit')"
      tabindex="3"
      :loading="isLoading"
      full-width
    />
  </form>
</template>
<script>
import VInput from '~/components/v-input/VInput.vue'
import VButton from '~/components/v-button/VButton.vue'
import signable from '~/mixins/signable'
import appendUrlParam from '~/utils/appendUrlParam'

export default {
  name: 'LoginForm',
  components: { VInput, VButton },
  mixins: [signable],
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    async login() {
      const params = {
        ...this.$store.getters.storeInfo,
      }

      try {
        this.isLoading = true
        const user = await this.$axios.$post(
          appendUrlParam('/users/login', params),
          this.getFormData()
        )
        this.setUser(user)
        this.redirectBack()
        this.emitSuccess()
      } catch (err) {
        this.$displayTopMessage(err.response?.data?.error || 'Ops.. :(', {
          type: 'error',
        })
      } finally {
        this.isLoading = false
      }
    },
    setUser(user) {
      this.$sentry.setUser(user || {})
      this.$store.commit('SET_USER', user)
    },
    getFormData() {
      return new FormData(this.$refs.form)
    },
  },
}
</script>

<style lang="scss">
.login-form {
  .input {
    margin-bottom: 15px;
  }

  .login-form__forgot-password {
    float: right;
    display: inline-block;
    color: $v4_color_text;
    margin-top: -5px;
    margin-bottom: 20px;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
